import { render, staticRenderFns } from "./comment-actions-bar.vue?vue&type=template&id=e6d7b960&"
import script from "./comment-actions-bar.vue?vue&type=script&lang=js&"
export * from "./comment-actions-bar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports